import React from 'react';

import "../../../styles/Pages/legal.css";


export const PolicyPage = () => {



    return <div className='plainDocumentPage fadeQuick' id="plainDocumentPage">

        <div className='innerAligner plainDocumentTextContainer'>

            <h1>PRIVACY NOTICE</h1>
            
            <div className='lastUpdatedText'>Last updated October 8, 2021 </div>
            <br />
            <br />
            <br />
            Thank you for choosing to be part of our community at Ayisen LLC ("Company", "we", "us", "our"). We are committed to protecting your personal information and your right to privacy. If you have any questions or concerns about this privacy notice, or our practices with regards to your personal information, please contact us at <a href="mailto:ayisenmain@gmail.com">ayisenmain@gmail.com. </a>
            <br />
            <br />
            When you visit our website ayisen.com (the "Website"), and more generally, use any of our services (the "Services", which include the Website), we appreciate that you are trusting us with your personal information. We take your privacy very seriously. In this privacy notice, we seek to explain to you in the clearest way possible what information we collect, how we use it and what rights you have in relation to it. We hope you take some time to read through it carefully, as it is important. If there are any terms in this privacy notice that you do not agree with, please discontinue use of our Services immediately.
            <br />
            <br />
            This privacy notice applies to all information collected through our Services (which, as described above, includes our Website), as well as, any related services, sales, marketing or events.
            <br />
            <br />
            Please read this privacy notice carefully as it will help you understand what we do with the information that we collect.
            <br />
            <br />


            <div className='plainDocumentSection'>
                <h3>
                1. WHAT INFORMATION DO WE COLLECT?
                </h3>
                
                <div>
                
                    <p>Personal information you disclose to us</p>

                    <p>In Short:  We collect personal information that you provide to us.</p>

                    We collect personal information that you voluntarily provide to us when you register on the Website, express an interest in obtaining information about us or our products and Services, when you participate in activities on the Website (such as by posting messages in our online forums or entering competitions, contests or giveaways) or otherwise when you contact us.
                    <br />
                    <br />
                    The personal information that we collect depends on the context of your interactions with us and the Website, the choices you make and the products and features you use. The personal information we collect may include the following:
                    <br />
                    <br />
                    Personal Information Provided by You. We collect names; email addresses; mailing addresses; usernames; passwords; debit/credit card numbers; billing addresses; contact or authentication data; and other similar information.
                    <br />
                    <br />
                    Payment Data. We may collect data necessary to process your payment if you make purchases, such as your payment instrument number (such as a credit card number), and the security code associated with your payment instrument. All payment data is stored by Stripe. You may find their privacy notice link(s) here: https://stripe.com/privacy.
                    <br />
                    <br />
                    All personal information that you provide to us must be true, complete and accurate, and you must notify us of any changes to such personal information.
                    <br />
                    <br />
                </div>
            </div>

            <div className='plainDocumentSection'>
                <h3>
                2. HOW DO WE USE YOUR INFORMATION?
                </h3>
                
                <div>
                
                    In Short:  We process your information for purposes based on legitimate business interests, the fulfillment of our contract with you, compliance with our legal obligations, and/or your consent.
                    <br />
                    <br />
                    We use personal information collected via our Website for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract with you, with your consent, and/or for compliance with our legal obligations. We indicate the specific processing grounds we rely on next to each purpose listed below.
                    <br />
                    <br />
                    We use the information we collect or receive:
                    To facilitate account creation and logon process. If you choose to link your account with us to a third-party account (such as your Google or Facebook account), we use the information you allowed us to collect from those third parties to facilitate account creation and logon process for the performance of the contract.
                    To post testimonials. We post testimonials on our Website that may contain personal information. Prior to posting a testimonial, we will obtain your consent to use your name and the content of the testimonial. If you wish to update, or delete your testimonial, please contact us at ayisenmain@gmail.com and be sure to include your name, testimonial location, and contact information.
                    Request feedback. We may use your information to request feedback and to contact you about your use of our Website.
                    To enable user-to-user communications. We may use your information in order to enable user-to-user communications with each user's consent.
                    To manage user accounts. We may use your information for the purposes of managing our account and keeping it in working order.
                    To send administrative information to you. We may use your personal information to send you product, service and new feature information and/or information about changes to our terms, conditions, and policies.
                    To protect our Services. We may use your information as part of our efforts to keep our Website safe and secure (for example, for fraud monitoring and prevention).
                    To enforce our terms, conditions and policies for business purposes, to comply with legal and regulatory requirements or in connection with our contract.
                    To respond to legal requests and prevent harm. If we receive a subpoena or other legal request, we may need to inspect the data we hold to determine how to respond.
                    <br />
                    <br />
                    Fulfill and manage your orders. We may use your information to fulfill and manage your orders, payments, returns, and exchanges made through the Website.
                    <br />
                    <br />
                    Administer prize draws and competitions. We may use your information to administer prize draws and competitions when you elect to participate in our competitions.
                    <br />
                    <br />
                    To deliver and facilitate delivery of services to the user. We may use your information to provide you with the requested service.
                    <br />
                    <br />
                    To respond to user inquiries/offer support to users. We may use your information to respond to your inquiries and solve any potential issues you might have with the use of our Services.
                    To send you marketing and promotional communications. We and/or our third-party marketing partners may use the personal information you send to us for our marketing purposes, if this is in accordance with your marketing preferences. For example, when expressing an interest in obtaining information about us or our Website, subscribing to marketing or otherwise contacting us, we will collect personal information from you. You can opt-out of our marketing emails at any time (see the "WHAT ARE YOUR PRIVACY RIGHTS" below).
                    Deliver targeted advertising to you. We may use your information to develop and display personalized content and advertising (and work with third parties who do so) tailored to your interests and/or location and to measure its effectiveness.
                    For other business purposes. We may use your information for other business purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Website, products, marketing and your experience. We may use and store this information in aggregated and anonymized form so that it is not associated with individual end users and does not include personal information. We will not use identifiable personal information without your consent.
                    <br />
                    <br />
                    3. WILL YOUR INFORMATION BE SHARED WITH ANYONE?
                    <br />
                    <br />
                    In Short:  We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations.
                    <br />
                    <br />
                    We may process or share your data that we hold based on the following legal basis:
                    Consent: We may process your data if you have given us specific consent to use your personal information for a specific purpose.
                    Legitimate Interests: We may process your data when it is reasonably necessary to achieve our legitimate business interests.
                    Performance of a Contract: Where we have entered into a contract with you, we may process your personal information to fulfill the terms of our contract.
                    Legal Obligations: We may disclose your information where we are legally required to do so in order to comply with applicable law, governmental requests, a judicial proceeding, court order, or legal process, such as in response to a court order or a subpoena (including in response to public authorities to meet national security or law enforcement requirements).
                    Vital Interests: We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding potential violations of our policies, suspected fraud, situations involving potential threats to the safety of any person and illegal activities, or as evidence in litigation in which we are involved.
                    More specifically, we may need to process your data or share your personal information in the following situations:
                    Business Transfers. We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
                    Other Users. When you share personal information (for example, by posting comments, contributions or other content to the Website) or otherwise interact with public areas of the Website, such personal information may be viewed by all users and may be publicly made available outside the Website in perpetuity. Similarly, other users will be able to view descriptions of your activity, communicate with you within our Website, and view your profile.
                    <br />
                    <br />

                </div>
            </div>

            
            <div className='plainDocumentSection'>
                <h3>
                4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
                </h3>

                <div>
                
                    In Short:  We may use cookies and other tracking technologies to collect and store your information.
                    <br />
                    <br />
                    We may use cookies and similar tracking technologies (like web beacons and pixels) to access or store information. Specific information about how we use such technologies and how you can refuse certain cookies is set out in our Cookie Notice.
                    <br />
                    <br />

                </div>
            </div>

            <div className='plainDocumentSection'>
                <h3>
                5. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY? 
                </h3>

                <div>
                
                    In Short:  We may transfer, store, and process your information in countries other than your own.
                    <br />
                    <br />
                    Our servers are located in. If you are accessing our Website from outside, please be aware that your information may be transferred to, stored, and processed by us in our facilities and by those third parties with whom we may share your personal information (see "WILL YOUR INFORMATION BE SHARED WITH ANYONE?" above), in and other countries.
                    <br />
                    <br />
                    If you are a resident in the European Economic Area, then these countries may not necessarily have data protection laws or other similar laws as comprehensive as those in your country. We will however take all necessary measures to protect your personal information in accordance with this privacy notice and applicable law.
                    <br />
                    <br />
                </div>
            </div>


            <div className='plainDocumentSection'>
                <h3>
                6. HOW LONG DO WE KEEP YOUR INFORMATION?
                </h3>
                
                <div>
                
                    In Short:  We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice unless otherwise required by law.
                    <br />
                    <br />
                    We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a longer retention period is required or permitted by law (such as tax, accounting or other legal requirements). 
                    <br />
                    <br />
                    When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.
                    <br />
                    <br />
                </div>
            </div>


            <div className='plainDocumentSection'>
                <h3>
                7. HOW DO WE KEEP YOUR INFORMATION SAFE?
                </h3>

                <div>      
                    In Short:  We aim to protect your personal information through a system of organizational and technical security measures.
                    <br />
                    <br />
                    We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security, and improperly collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our Website is at your own risk. You should only access the Website within a secure environment.
                    <br />
                    <br />
                </div>   
            </div>       

            <div className='plainDocumentSection'>
                <h3>
                8. DO WE COLLECT INFORMATION FROM MINORS?
                </h3>
                
                <div>
                    In Short:  We do not knowingly collect data from or market to children under 18 years of age.
                    <br />
                    <br />
                    We do not knowingly solicit data from or market to children under 18 years of age. By using the Website, you represent that you are at least 18 or that you are the parent or guardian of such a minor and consent to such minor dependent’s use of the Website. If we learn that personal information from users less than 18 years of age has been collected, we will deactivate the account and take reasonable measures to promptly delete such data from our records. If you become aware of any data we may have collected from children under age 18, please contact us at ayisenmain@gmail.com.
                    <br />
                    <br />
                </div>
            </div>

            <div className='plainDocumentSection'>
                <h3>
                9. WHAT ARE YOUR PRIVACY RIGHTS?
                </h3>
                
                <div>
                
                    In Short:  You may review, change, or terminate your account at any time.
                    <br />
                    <br />
                    If you are a resident in the European Economic Area and you believe we are unlawfully processing your personal information, you also have the right to complain to your local data protection supervisory authority. You can find their contact details here: http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm.
                    <br />
                    <br />
                    If you are a resident in Switzerland, the contact details for the data protection authorities are available here: https://www.edoeb.admin.ch/edoeb/en/home.html.
                    <br />
                    <br />
                    If you have questions or comments about your privacy rights, you may email us at stevenmeara2@gmail.com.
                    <br />
                    <br />
                    Account Information
                    <br />
                    <br />
                    If you would at any time like to review or change the information in your account or terminate your account, you can:
                    Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, we may retain some information in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our Terms of Use and/or comply with applicable legal requirements.
                    <br />
                    <br />
                    Cookies and similar technologies: Most Web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove cookies and to reject cookies. If you choose to remove cookies or reject cookies, this could affect certain features or services of our Website. To opt-out of interest-based advertising by advertisers on our Website visit http://www.aboutads.info/choices/.
                    <br />
                    <br />
                    Opting out of email marketing: You can unsubscribe from our marketing email list at any time by clicking on the unsubscribe link in the emails that we send or by contacting us using the details provided below. You will then be removed from the marketing email list — however, we may still communicate with you, for example to send you service-related emails that are necessary for the administration and use of your account, to respond to service requests, or for other non-marketing purposes. To otherwise opt-out, you may:
                    <br />
                    <br />
                </div>
            </div>

            <div className='plainDocumentSection'>
                <h3>
                10. CONTROLS FOR DO-NOT-TRACK FEATURES
                </h3>
                
                <div>
                
                    Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track ("DNT") feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage no uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this privacy notice. 
                    <br />
                    <br />
                </div>
            </div>

            <div className='plainDocumentSection'>
                <h3>
                11. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
                </h3>

                <div>              
                    In Short:  Yes, if you are a resident of California, you are granted specific rights regarding access to your personal information.
                    <br />
                    <br />
                    California Civil Code Section 1798.83, also known as the "Shine The Light" law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us using the contact information provided below.
                    <br />
                    <br />
                    If you are under 18 years of age, reside in California, and have a registered account with the Website, you have the right to request removal of unwanted data that you publicly post on the Website. To request removal of such data, please contact us using the contact information provided below, and include the email address associated with your account and a statement that you reside in California. We will make sure the data is not publicly displayed on the Website, but please be aware that the data may not be completely or comprehensively removed from all our systems (e.g. backups, etc.).
                    <br />
                    <br />
                </div>
            </div>

            <div className='plainDocumentSection'>
                <h3>
                12. DO WE MAKE UPDATES TO THIS NOTICE?
                </h3>
                
                <div>
                
                    In Short:  Yes, we will update this notice as necessary to stay compliant with relevant laws.
                    <br />
                    <br />
                    We may update this privacy notice from time to time. The updated version will be indicated by an updated "Revised" date and the updated version will be effective as soon as it is accessible. If we make material changes to this privacy notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy notice frequently to be informed of how we are protecting your information.
                    <br />
                    <br />
                </div>
            </div>

            <div className='plainDocumentSection'>
                <h3>
                13. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?   
                </h3>

                <div>
                    If you have questions or comments about this notice, you may email us at <a href='mailto:ayisenmain@gmail.com'>ayisenmain@gmail.com</a>
                    <br />
                    <br />
                </div>
            </div>


            <div className='plainDocumentSection'>
                <h3>
                14. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?     
                </h3>
                
                <div>
                    Based on the applicable laws of your country, you may have the right to request access to the personal information we collect from you, change that information, or delete it in some circumstances. We will respond to your request within 30 days.
                    <br />
                    <br />
                </div>
            </div>
                

        </div>


    </div>


}

export default PolicyPage;